<template>
<div> 
<b-form @submit="onSubmit" @reset="onReset" class="form-signin">
    <div class="mb-4">
      <b-avatar class="avatar-login"></b-avatar>
    </div>    
    <h1 class="h3 mb-3 font-weight-normal">{{$t('login.titol')}}</h1>
    <b-form-group
        id="input-group-1"
        label=""
        label-for="input-1"
    >
        <b-form-input
            id="input-1"
            v-model="form.usuari"
            type="text"
            required
            :placeholder='$t("login.usuari")'
        ></b-form-input>        
    </b-form-group>
    <b-form-group id="input-group-2" label="" label-for="input-2">
        <b-form-input
        id="input-2"
        v-model="form.pass"
        type="password"
        required
        :placeholder='$t("login.pass")'
        ></b-form-input>
    </b-form-group>
    <p class="login-error" v-if="hasLoginError" >{{$t('login.error')}}</p>
    <b-button type="submit" variant="primary">{{$t('btn.entrar')}}</b-button>

</b-form>
</div>

</template>

<script>
import loginService from "../services/LoginService";

export default {
    data() {
      return {
        form: {
          usuari: '',
          pass: ''
        },
        hasLoginError: false
      }
    },
    methods: {
      onSubmit(evt) {
        evt.preventDefault();
        this.hasLoginError = false;
        loginService.login(this.form).then(response => {                      
            if(response.data.redirect_to && response.data.redirect_to != ''){
                this.$router.push(response.data.redirect_to);
            }
            this.$parent.login();
        })
        .catch(e => {
          console.log(e);
          this.hasLoginError = true;
        });

      },
      onReset(evt) {
        evt.preventDefault();
        this.form.usuari = '';
        this.form.pass = '';
        this.hasLoginError = false;
      }
    },
    mounted() {
      loginService.logout();
      this.$parent.logout();         
    }
}
</script>

<style>
.form-signin {
  width: 100%;
  max-width: 320px;
  padding: 15px;
  margin: 0 auto;
}
.avatar-login {
  width: 5em !important;
  height: 5em !important;
}
.login-error {
    font-size: 0.8rem;
    color: #dc3545;
}
</style>